import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from '../../methods';

const settingsGetCompanionContexts = () =>
  getRequest('settings/companion_contexts');

const settingsGetCompanionContext = (id: number) =>
  getRequest(`settings/companion_contexts/${id}`);

const settingsCreateCompanionContext = (payload: object) =>
  postRequest('settings/companion_contexts', payload);

const settingsUpdateCompanionContext = (id: number, payload: object) =>
  patchRequest(`settings/companion_contexts/${id}`, payload);

const settingsDeleteCompanionContext = (id: number) =>
  deleteRequest(`settings/companion_contexts/${id}`);

const companionContexts = {
  settingsGetCompanionContexts,
  settingsGetCompanionContext,
  settingsCreateCompanionContext,
  settingsUpdateCompanionContext,
  settingsDeleteCompanionContext,
};

export default companionContexts;
